const makeTemplatesQueryParams = (searchBy = '', contentType = '') => {
  return `limit=0&search=${searchBy}:1;content_type:${contentType}`;
};


export default makeTemplatesQueryParams;
